var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pendo-modal',{staticClass:"path-delete-modal",attrs:{"height":"auto","type":"confirmation","visible":_vm.isVisible,"title":"Delete Path?","confirm-button-config":{
        type: 'danger',
        label: 'Delete Path',
        theme: 'app',
        loading: _vm.isRemoving
    },"cancel-button-config":{ type: 'secondary', theme: 'app' },"message":_vm.modalMessage},on:{"close":function($event){return _vm.$emit('close')},"cancel":function($event){return _vm.$emit('close')},"confirm":_vm.deleteReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }